import { useEffect } from "react";
import { saveState } from "store/grids";
export const serializeColumnState = (columnState) => columnState.map((col) => ({
    aggFunc: typeof col.aggFunc === "string" ? col.aggFunc : undefined,
    colId: col.colId,
    flex: col.flex,
    hide: col.hide,
    pinned: col.pinned,
    pivot: col.pivot,
    pivotIndex: col.pivotIndex,
    rowGroup: col.rowGroup,
    rowGroupIndex: col.rowGroupIndex,
    sort: col.sort,
    sortIndex: col.sortIndex,
    width: col.width
}));
export const restoreColumnStateToGrid = (grid, latestColumnState, storedColumnState) => {
    if (!grid.current?.api) {
        return;
    }
    const stateToApply = latestColumnState.current?.length > 0
        ? latestColumnState.current
        : storedColumnState;
    if (stateToApply && stateToApply.length > 0) {
        grid.current.api.applyColumnState({
            applyOrder: true,
            state: stateToApply
        });
    }
};
export const createColumnStateUpdater = (latestColumnState, dispatch, stateId, existingColumnState) => (event) => {
    const currentColumnState = event.api.getColumnState();
    latestColumnState.current = currentColumnState;
    const sortedColumn = currentColumnState.find((col) => col.sort !== null)?.colId;
    const columnDefs = event.api.getColumnDefs();
    const filteredColumnDefs = columnDefs.filter((colDef) => !colDef.hide && colDef.groupId);
    const groupedColumns = filteredColumnDefs.flatMap((e) => e.children.map((child) => child.colId));
    const getSortedColumnGroupId = groupedColumns.findIndex((e) => e === sortedColumn);
    if (getSortedColumnGroupId !== -1) {
        event.api.setColumnGroupOpened(groupedColumns[getSortedColumnGroupId], true);
    }
    const serializableColumnState = serializeColumnState(currentColumnState);
    const mergedColumnState = serializableColumnState.map((newCol) => {
        const existingCol = existingColumnState?.find((col) => col.colId === newCol.colId);
        // Only preserve rowGroup state, but always use new rowGroupIndex from AG Grid
        if (existingCol && existingCol.rowGroup && newCol.rowGroupIndex === undefined) {
            return {
                ...newCol,
                rowGroup: existingCol.rowGroup
            };
        }
        return newCol;
    });
    dispatch(saveState({
        columns: mergedColumnState,
        id: stateId
    }));
};
export const createSortHandler = (updateColumnState) => (event) => {
    if (event.api) {
        updateColumnState(event);
        event.api.refreshCells();
    }
};
export const createColumnMovedHandler = (updateColumnState) => (event) => {
    if (event.api) {
        updateColumnState(event);
    }
};
export const useColumnStateSynchronization = (columnState, latestColumnState) => {
    useEffect(() => {
        if (columnState && columnState.length > 0) {
            const hasGroupingChanges = columnState.some((reduxCol) => {
                const refCol = latestColumnState.current.find((c) => c.colId === reduxCol.colId);
                return reduxCol.rowGroup !== refCol?.rowGroup ||
                    reduxCol.rowGroupIndex !== refCol?.rowGroupIndex;
            });
            if (hasGroupingChanges || latestColumnState.current.length === 0) {
                latestColumnState.current = columnState;
            }
        }
    }, [columnState, latestColumnState]);
};
export const useSearchTriggeredRestore = (grid, search, restoreColumnState) => {
    useEffect(() => {
        if (grid.current?.api && search !== undefined) {
            restoreColumnState();
        }
    }, [search, restoreColumnState, grid]);
};
